// 0 км у НОВОЙ машины — это и есть пробег, а не пропуск (#1441): на демо-стоке
// 16 новых машин показывали «N/A». У подержанной 0 по-прежнему значит «не
// указан» — так его отдают фиды дилеров.
export const formatMileage = (mileage, condition) => {
  if (mileage === 0 && String(condition).toLowerCase() === 'new') return '0 km';
  if (!mileage || mileage === 0) return 'N/A';
  return `${mileage.toLocaleString()} km`;
};
